import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.3334 9.66671V17.1667H16.6667V14.6667H3.33335V17.1667H1.66669V3.83337H3.33335V12.1667H10V6.33337H15C15.8841 6.33337 16.7319 6.68456 17.357 7.30968C17.9822 7.93481 18.3334 8.78265 18.3334 9.66671ZM6.66669 11.3334C6.00365 11.3334 5.36776 11.07 4.89892 10.6011C4.43008 10.1323 4.16669 9.49642 4.16669 8.83337C4.16669 8.17033 4.43008 7.53445 4.89892 7.06561C5.36776 6.59677 6.00365 6.33337 6.66669 6.33337C7.32973 6.33337 7.96561 6.59677 8.43445 7.06561C8.9033 7.53445 9.16669 8.17033 9.16669 8.83337C9.16669 9.49642 8.9033 10.1323 8.43445 10.6011C7.96561 11.07 7.32973 11.3334 6.66669 11.3334Z",
  fill: "#717179"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}